import { jsx as _jsx } from "react/jsx-runtime";
import { BillingMainDialog } from 'console/billing/main-dialog';
import { BillingDialogContent } from 'console/billing/billing-dialog/content';
import { BuyH2000PlusSuccess, H2000PlusFirmwareContent, } from 'console/entities/billing.h2000-firmware/ui';
import { TariffChooserContent } from 'console/billing/account-tariff/tariff';
import { ConfirmationPage } from './account-tariff/confirmation-page';
import { BuyDesignPackage } from './package-custom-design/buy-package';
import { BuySocket03ThermostatDialog } from 'entities/billing.buy-socket-03-thermostat/ui';
export const billingRoutes = [
    {
        path: '/billing',
        element: _jsx(BillingMainDialog, {}),
        children: [
            {
                path: 'main',
                element: _jsx(BillingDialogContent, {}),
            },
            {
                path: 'tariff',
                element: _jsx(TariffChooserContent, {}),
            },
            {
                path: 'tariff/:tariff_id',
                element: _jsx(ConfirmationPage, {}),
            },
            {
                path: 'more-icons',
                element: _jsx(BuyDesignPackage, {}),
            },
            {
                path: 'firmware-h-2000-plus',
                element: _jsx(H2000PlusFirmwareContent, {}),
                children: [
                    {
                        path: 'success',
                        element: _jsx(BuyH2000PlusSuccess, {}),
                    },
                ],
            },
            {
                path: 'sockets-03-thermostat',
                element: _jsx(BuySocket03ThermostatDialog, {}),
            },
        ],
    },
];
